var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        {
          staticClass: "form-item select-item",
          class: [_vm.item.data.htmloptions, _vm.isInvalid ? "is-invalid" : ""],
        },
        [
          _c(
            "div",
            {
              staticClass: "select-item__select",
              on: { click: _vm.toggleOptions },
            },
            [
              _c("span", [_vm._v(" " + _vm._s(_vm.selectedOption.label))]),
              _vm._v(" "),
              _c("i", { staticClass: "icon-arrow-down" }),
            ]
          ),
          _vm._v(" "),
          _vm.showOptions
            ? _c(
                "ul",
                { staticClass: "select-item__options" },
                _vm._l(_vm.answeroptions, function (answer) {
                  return _c(
                    "li",
                    {
                      key: answer.id,
                      on: {
                        click: function ($event) {
                          return _vm.setOption(answer)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(answer.label) + "\n        "
                      ),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c("Label", {
            attrs: {
              errors: _vm.errors,
              "is-invalid": _vm.isInvalid,
              item: _vm.item,
            },
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selectedOption.value,
                expression: "selectedOption.value",
              },
            ],
            attrs: { name: _vm.item.data.id, type: "hidden" },
            domProps: { value: _vm.selectedOption.value },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.selectedOption, "value", $event.target.value)
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }